import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import Header from 'components/Header';
import Button from 'components/Button';
import Modal from 'components/Modal';
import ApplicationId from 'components/ApplicationId';

import { formatCurrency } from 'utils/formatCurrency';

// Configuration & Assets
import { useConfig } from 'config/ConfigContext';
import './style.scss';

import {
  newNextAction,
} from '../../actions/navigation';

const AgreementSign = (props) => {
  const config = useConfig();
  const { checkinData, params, searchParams } = props;
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const onMessageReceived = (event) => {
    const { data } = event;
    const { navigate, dispatch } = props;

    let dataJson = {};
    try {
      dataJson = JSON.parse(data);
    } catch (error) {
      console.log('error', error);
    }

    const key = searchParams.get('key');

    if (dataJson.event === 'session_view.document.completed') {
      if (key) {
        const workflowType = get(params, 'workflowType') || 'text2apply';

        dispatch(newNextAction({
          key,
          workflowType,
          data: {
            event: dataJson.event,
            eid: dataJson.data.uuid,
            id: dataJson.applicationId,
            error: null,
          },
          success: (response) => {
            const routeUrl = response.data && response.data.url.replace(config.hostUrl, '');
            navigate(routeUrl);
          },
        }));
      }
    }
  };

  useEffect(() => {
    const { navigate, dispatch } = props;
    const key = searchParams.get('key');

    const iframe = document.getElementById('docusign');
    if (iframe && iframe.contentDocument) {
      const workflowCompleteBtn = iframe.contentDocument.getElementById('workflowComplete');
      if (workflowCompleteBtn) {
        workflowCompleteBtn.addEventListener('click', () => {
          if (key) {
            const workflowType = get(params, 'workflowType') || 'text2apply';
            dispatch(newNextAction({
              key,
              workflowType,
              success: () => {
                navigate(`/?key=${key}`);
              },
            }));
          }
        });
      }
    }

    window.addEventListener('message', onMessageReceived, false);
    return () => {
      window.removeEventListener('message', onMessageReceived, false);
    };
  }, []);

  useEffect(() => {
    const { navigate } = props;
    const workflowType = get(params, 'workflowType');

    if (get(checkinData, ['data', 'data']) === undefined) {
      navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${searchParams.get('key')}`);
    }
  }, [checkinData]);

  const handleButtonClick = () => {
    setIsPopupVisible(true);
  };

  const handleClosePopup = () => {
    setIsPopupVisible(false);
  };

  return (
    <div className="transition-item wrapper agreement">
      <Header />
      <ApplicationId id={get(checkinData, 'attributes.entityId')} style={{ marginTop: 10 }} />
      {get(checkinData, ['data', 'data', 'errorMessage']) ? (
        <p style={{ color: '#D82028' }} dangerouslySetInnerHTML={{ __html: get(checkinData, ['data', 'data', 'errorMessage']) }} />
      ) : (
        <Button
          className="btn btn-sm header-btn"
          title="Definitions"
          onClick={handleButtonClick}
        />
      )}
      <div className="content appIdVisible">
        <iframe
          src={`${get(checkinData, ['data', 'data', 'url'])}`}
          title="docusign"
          width="100%"
          height="651px"
          frameBorder="0"
        />
      </div>
      {
        isPopupVisible
        && (
        <Modal>
          <div className="card-content-definition">
            <div className="card-header">
              <h5>Definitions</h5>
            </div>
            <div className="close" onClick={handleClosePopup} />
            <div className="card-content docusign-definition-card">
              <div>
                <b>No Interest on Principal Option Promotion -</b>
                {' '}
                Your loan may have a No Interest on Principal Option Promotion included. This promotion can save you money if you pay off the principal amount of the loan in full within the Promotional Period (&#34;Promotional Period&#34;). During the Promotional Period you will be responsible for making all of your monthly payments and your loan will accrue interest on a monthly basis. If you pay off your loan within the Promotional Period, the monthly payments that you have made during this period, which includes accrued interest, will be deducted from the principal amount of the loan. Length of Promotional Periods vary, please review your loan agreement for full details.
              </div>
              <br />
              <div>
                <b>APR - An Annual Percentage Rate (APR)</b>
                {' '}
                is the annual rate charged to borrow funds, inclusive of all fees and charges. LendingUSA calculates APR by combining the Interest Rate and Origination Fees to provide a simple annual rate.
              </div>
              <br />
              <div>
                <b>Origination Fee -</b>
                {' '}
                An origination fee of up to 8% may be included in your loan, please review your Loan Agreement for full details.
              </div>
              <br />
              <div>
                <b>Interest Rate -</b>
                {' '}
                The interest Rate is the percent of principal charged by the Lender for the use of its funds.
              </div>
              <br />
              <div>
                <b>Late Fee -</b>
                {' '}
                A Late Fee of up to $
                {formatCurrency(get(checkinData, ['data', 'data', 'maxLateFee'], 0), 2)}
                {' '}
                will be assessed if you fail to make a payment within 16 days of its scheduled due date.
              </div>
              <br />
              Please call LendingUSA directly with any questions regarding the loan or its terms at
              {' '}
              <b>800-944-6177</b>
              .
            </div>
          </div>
        </Modal>
        )
      }
    </div>
  );
};

AgreementSign.propTypes = {
  navigate: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(AgreementSign);
